<template>
    <div>
        <el-container class="mainInfo" v-loading="mainLoading">
            <el-main>
                <toolBar :loading.sync="mainLoading"
                         :searchData="searchData"
                         @search="search"
                         @excel="excel">
                </toolBar>
                <tableGrid ref="tableGrid"
                           :sumObject="sumObject"
                           :showSummary="showSummary"
                           adaptiveHeight="123"
                           :headList="headList"
                           :dataList="dataList"
                           :pageInfo="pageInfo"
                           @tableOpt="tableOpt"
                           @toPage="toPage"
                           :loading="loading">
                </tableGrid>
            </el-main>
        </el-container>
    </div>
</template>

<script>
    import toolBar from '@/components/page/sale/profitstatisbyproduct/toolBar'
    import tableGrid from '@/components/tools/table'

    export default {
        name: "profitstatisbyproduct",
        props: ['menuData'],
        components: {tableGrid,toolBar},
        data() {
            return {
                showSummary:true,
                sumObject: {},
                mainLoading: false,
                searchData: {
                    formData:{}
                },

                width: "350px",
                dialogLoading: false,
                formData: {},
                tableH: 100,
                dataList: [],
                loading: false,
                headList: [
                    {column_name: "_px", column_comment: "序号", column_width: "70"},
                    {column_name: "departmentNameBill", column_comment: "所属单位", column_width: "150"},
                    {column_name: "typeName", column_comment: "物资分类", column_width: "100"},
                    {column_name: "proName", column_comment: "物资名称", column_width: "150"},
                    {column_name: "proCode", column_comment: "物资编码", column_width: "100"},
                    {column_name: "units", column_comment: "物资计量单位", column_width: "100"},
                    {column_name: "specification", column_comment: "规格型号", column_width: "100"},
                    {column_name: "origin", column_comment: "产地", column_width: "100"},
                    {column_name: "color", column_comment: "颜色", column_width: "100"},
                    {column_name: "num", column_comment: "数量", column_width: "150"},
                    {column_name: "total", column_comment: "未税金额", column_width: "150"},
                    {column_name: "tax", column_comment: "税额", column_width: "150"},
                    {column_name: "taxTotal", column_comment: "含税金额", column_width: "150"},
                    {column_name: "costTotal", column_comment: "成本合计", column_width: "150",type:'custom',
                        render: (h, data) => {
                            return h('div',this.$pub.getPrecisionData(data.costTotal,this.precisionTotal));
                        }
                    },
                    {column_name: "profitTotal", column_comment: "利润合计", column_width: "150"},
                    {column_name: "profitRate", column_comment: "利润率", column_width: "150"},
                ],
                pageInfo: {
                    page: 1,
                    pagesize: 20,
                    pageSizes: [10, 20, 50, 100],
                    total: 0,
                }
            }
        },
        methods: {
            async getListData() {
                this.loading = true;
                let param = {
                    url: "/profitstatistics/listProfitStatisByProduct",
                    param: {
                        ...this.searchData.formData,
                        limit: this.pageInfo.pagesize,
                        page: this.pageInfo.page
                    }
                }
                const data = await this.$store.dispatch('pubMethod', param)
                if (data.infoCode == "0") {
                    this.dataList = data.data.jsonObject.data;
                    this.sumObject = data.data.sumObject;
                    this.pageInfo.total = data.data.jsonObject.count;
                }
                this.loading = false;
            },
            toPage() {
                this.getListData();
            },
            search(data) {
                this.searchData.formData = data;
                this.pageInfo.page = 1;
                this.getListData();
            },
            excel(data) {
                this.searchData.formData = data;

                let param = {
                    url: "/profitstatistics/excelProfitStatisByProduct",
                    param: {
                        ...this.searchData.formData
                    }
                }
                this.$pub.openPostWindow(param);
            },
            reBack(){
                this.getListData();
                this.activeName = "first";
            },
            refresh() {
                this.getListData();
            },
            tableOpt() {
            },
            headerStyle() {
                return "text-align:center;height:35px;line-height:35px;padding: 5px 0;background-color:#f2f2f2;border-left:1px solid #e5e6e8;border-top:1px solid #e5e6e8;border-bottom:1px solid #e5e6e8"
            },
            cellStyle() {
                return "text-align:center"
            },
        }
    }
</script>
